<div class="userProfile" *ngIf="baseAccount">
  <button
    mat-button
    (click)="onMenuTriggered()"
    [matMenuTriggerFor]="menu"
    data-testid="account-details"
    class="text-initial"
  >
    <app-account-signature
      [account]="baseAccount"
      [useOnlyAvatar]="true"
      [shouldDisplayTooltip]="false"
      [avatarSize]="'medium'"
    ></app-account-signature>
    <div class="userProfile_info d-none d-lg-flex flex-column text-left ml-2">
      <span class="text-left text-truncate">{{baseAccount | accountDisplayName}}</span>
      <span data-testid="selectedClient" class="text-none text-small text-muted text-truncate">
        {{selectedClient?.name}}
      </span>
    </div>
    <mat-icon class="iconRight" svgIcon="menu-down"></mat-icon>
  </button>
  <mat-menu #menu="matMenu" xPosition="before" class="m-2">
    <div class="userProfile_accountSection">
      <app-account-signature
        class="mb-2"
        [account]="baseAccount"
        [useOnlyAvatar]="true"
        [shouldDisplayTooltip]="false"
        [avatarSize]="'jumbo'"
      ></app-account-signature>

      <div>{{baseAccount | accountDisplayName}}</div>
      <div class="text-small text-muted">{{baseAccount.email}}</div>

      <a
        [class.disabled]="!isAppOnline ? true : null"
        (click)="isAppOnline ? navigateToMyAccount() : $event.stopPropagation()"
      >
        <span i18n="@@shared.accountDetails.btnMyAccount">My Account</span>
      </a>
    </div>

    <ng-container *ngIf="(clientsList && isAppOnline); else offlinePlaceholder">
      <div class="accountPicker">
        <button
          mat-menu-item
          class="accountPicker_item"
          [attr.data-testid]="client.name"
          *ngFor="let client of clientsList | sort : 'name' : 'asc' : false; trackBy: trackClient"
          [ngStyle]="{'cursor': (client.id === selectedClient?.id) ? 'default' : 'pointer'}"
          [ngClass]="{'selectedMenuItem' : (client.id === selectedClient?.id)}"
          (click)="(client.id !== selectedClient?.id) && onSelectClient(client)"
        >
          <div class="d-flex w-100 align-items-center text-truncate">
            <div class="text-truncate">
              <div [title]="client.name" class="text-truncate">{{client.name}}</div>
              <div
                class="text-small text-muted"
                *ngIf="client.id === selectedClient?.id"
                i18n="@@shared.accountDetails.txtActiveSession"
              >
                Active session
              </div>
            </div>
            <ng-container *ngIf="client?.logoUrl; else logoPlaceholder">
              <img class="accountPicker_logo ml-auto pl-1" [src]="client?.logoUrl" [alt]="client.name" />
            </ng-container>
            <ng-template #logoPlaceholder>
              <span class="ml-auto">&nbsp;</span>
            </ng-template>
          </div>
        </button>
      </div>
    </ng-container>
    <ng-template #offlinePlaceholder>
      <button mat-menu-item class="accountPicker_item selectedAccount offlinePlaceholder">
        <div class="d-flex w-100 align-items-center text-truncate">
          <div class="text-truncate">
            <div [title]="selectedClient?.name" class="text-truncate">{{selectedClient?.name}}</div>
            <div class="text-small text-muted" i18n="@@shared.accountDetails.txtActiveSessionOffline">
              Active session
            </div>
          </div>
          <ng-container *ngIf="selectedClient?.logoUrl; else logoPlaceholder">
            <img
              class="accountPicker_logo ml-auto pl-1"
              appOfflineLogo
              [src]="selectedClient?.logoUrl"
              [base64EncodedLogoContent]="selectedClient?.base64EncodedLogoContent"
              alt=""
            />
          </ng-container>
          <ng-template #logoPlaceholder>
            <span class="ml-auto">&nbsp;</span>
          </ng-template>
        </div>
      </button>
    </ng-template>

    <div
      class="appVersion"
      mat-menu-item
      matTooltip="Copy version number to clipboard"
      i18n-matTooltip="@@shared.accountDetails.attrCopyToClipboard"
      [cdkCopyToClipboard]="appVersion"
      (click)="copyToClipboardNotification()"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="text-small text-muted">{{appVersion}}</div>
        <mat-icon svgIcon="content-copy"></mat-icon>
      </div>
    </div>

    <button
      matTooltip="Signing out is not possible in offline mode"
      [matTooltipDisabled]="isAppOnline"
      i18n-matTooltip="@@shared.accountDetails.btnSignOutOffline"
      [disabled]="!isAppOnline"
      mat-menu-item
      (click)="onSignOut()"
      data-testid="sign-out"
    >
      <mat-icon svgIcon="logout"></mat-icon>
      <span i18n="@@shared.accountDetails.btnSignOut">Sign out</span>
    </button>
  </mat-menu>
</div>
